<template>
    <div class="search-panel__filter-result">
        <div v-if="windowWidth < 960" class="grid__container">
            <a :href="link.href" :class="['button', 'button_size_mega', 'button_theme_search-panel', {'is-disabled': link.disabled}]">
                <div class="button__content">
                    <span class="button__text">{{ link.text }}</span>
                </div>
            </a>
        </div>
        <a v-else :href="link.href" :class="['button', 'button_size_mega', 'button_theme_search-panel', {'is-disabled': link.disabled}]">
            <div class="button__content">
                <span class="button__text">{{ link.text }}</span>
            </div>
        </a>
    </div>
</template>

<script>

export default {
    props: ['link', 'windowWidth']
};
</script>
